<div class="flex flex-col flex-wrap items-end gap-1 text-xs font-normal">
  <div class="text-end">
    Koszt dostawy został powiększony o dodatkowe opłaty związane z realizacją
    zamówienia w kilku osobnych przesyłkach -

    <span class="inline-flex flex-wrap gap-1">
      <div class="font-bold">{{ quantity() }}</div>
      <div class="font-bold">x</div>
      <div class="font-bold">
        <app-currency [amount]="unitPrice()" />
      </div>
      <div class="-ml-1">.</div>
    </span>
  </div>
</div>
